import React from 'react'
import { Offcanvas } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { corporateSiteUrl } from '@environments/environment'

const listMenu = [
  {
    path: '/',
    name: 'TOP'
  },
  {
    path: '#',
    name: '新規加盟店舗のお知らせ',
    external: 'https://www.instagram.com/gmts_official/'
  },
  {
    path: '/vote2022',
    name: 'アンバサダー投票'
  },
  {
    path: '#',
    name: 'GMTSサービス加入',
    external: `${corporateSiteUrl}/touroku/`
  },
  {
    path: '#',
    name: 'サービス紹介',
    external: `${corporateSiteUrl}/price/`
  },
  {
    path: '#',
    name: 'ご利用までの流れ',
    external: `${corporateSiteUrl}/how-to-start/`
  },
  {
    path: '#',
    name: 'よくある質問',
    external: `${corporateSiteUrl}/faq/`
  }
]

export default function SidebarMenu ({ show, onClose }: any) {
  return (
    <Offcanvas show={show} placement="end" onHide={onClose} id="sidebar">
      <Offcanvas.Header closeButton closeVariant="white">
        <Offcanvas.Title>
          {/* <button id="dismiss" onClick={onClose}>
            <i className="bi bi-x-lg" />
          </button> */}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="sidebar-header">
          <ul>
            {listMenu.map(menu => (
              <li key={menu.name}>
                {menu.external
                  ? <a href={menu.external} target="_blank" rel="noreferrer">{menu.name}</a>
                  : <Link to={menu.path} onClick={onClose}>{menu.name}</Link>}
              </li>
            ))}
          </ul>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  )
}
